import React from "react";

export const AdContext = React.createContext();